export default "__VITE_ASSET__nY8D2nS2__"